import React, { Dispatch, ReactNode, SetStateAction } from "react";
import { Box, Button, Collapse, Stack, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";

interface SearchCategoryProps<T> {
    results?: T[];
    children: ReactNode | ReactNode[];
    searchText: string;
    categoryTitle: string;
    limitExceeded?: boolean;
    open: boolean;    
    setOpen: Dispatch<SetStateAction<boolean>>;
}

const SearchCategory = <T,>(props: SearchCategoryProps<T>) => {

    return (
        <>
            {props.results !== undefined && props.results.length > 0 &&
                <Stack direction="row" spacing={2}>
                    <Box>
                        <Button variant="contained" sx={{ minWidth: '0px', padding: '4px 8px' }} onClick={() => props.setOpen(!props.open)}>{props.open 
                            ? <FontAwesomeIcon fontSize="small" icon={faMinus} />
                            : <FontAwesomeIcon fontSize="small" icon={faPlus} />}</Button >
                    </Box>
                    <Box>
                        <Typography variant='body1'>{props.categoryTitle} ({props.results?.length} results)</Typography>
                        {props.limitExceeded === true ? <Typography color="error">limit exceeded</Typography> : <></>}
                        <Collapse in={props.open}>
                            <Box>
                                <Stack direction="row" sx={{ flexWrap: 'wrap' }}>
                                    <Stack direction="row" sx={{ flexWrap: 'wrap' }}>
                                        {props.children}
                                    </Stack>
                                </Stack>
                            </Box>
                        </Collapse>
                    </Box>
                </Stack>
            }
        </>
    )
}

export default SearchCategory;